import {
  ABMNotification,
  ConversationNotification,
  ExternalNotification
} from '../typings/notifications'

export interface AppServices {
  notifications: NotificationService
  badges: BadgeService
  auth: AuthService
  util: UtilService
  reload: ReloadService
  redux: ReduxService
}

export declare enum DesktopPushNotificationType {
  CHAT = "CHAT",
  PARTICIPANTS_ADDED = "PARTICIPANTS_ADDED",
  CONVERSATION_CLASSIFIED = "CONVERSATION_CLASSIFIED",
  VIDEO_VIEW_PUSH = "video_view_push"
}

export interface NotificationService {
  sendNotification: (notification: ConversationNotification) => Promise<void>
  sendABMNotification: (notification: ABMNotification) => Promise<void>
  sendExternalNotification: (notification: ExternalNotification) => Promise<void>
}

export interface BadgeService {
  showBadgeIconNumber: (numberOfUnreadConversations: number) => Promise<void>
  isWindowVisible: () => Promise<boolean>
}

export interface AuthService {
  openWebLogin: () => void
  logout: () => void
}

export interface UtilService {
  log: (entry: any) => void
}

export interface ReloadService {
  reloadApplication: () => void
}

export interface ReduxService {
  sendAction: (action: any) => void
}

let appServices: AppServices

export const registerAppServices = (services: AppServices): void => {
  appServices = services
}

export const getAppServices = (): AppServices => {
  if (!appServices) {
    throw new Error('Conversation App services not yet registered')
  }

  return appServices
}
